import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import image23 from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale/sections/sections/images/23.png";
import imgPardoseli114 from "assets/images/poze-site/11-4-pardoseli.webp";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    <MKTypography variant="h2" mb={3} color="dark">
                        Curățenie hale industriale și depozite – pentru un mediu sigur și curat
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Curățenia halelor industriale este un proces critic pentru orice agent
                        economic care dorește să mențină un flux de producție eficient și un mediu
                        de lucru protejat. La Doral Cleaning, abordăm fiecare proiect cu
                        rigurozitatea necesară unui spațiu tehnic, asigurându-ne că standardele de
                        igienă sunt respectate fără compromisuri.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Conform studiilor europene privind mentenanța, un spațiu industrial curat
                        poate reduce rata accidentelor de muncă cu până la 15%.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/PZy7XVb7/curatenie-hale-industriale-doral-cleaning.png"
                        alt="Curățenie hale industriale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        my={4}
                    />

                    <MKTypography variant="h3" mb={3} color="dark" mt={3}>
                        Servicii de curățare hale, fabrici și depozite
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Procesele de igienizare în mediile de producție necesită o abordare diferită
                        față de spațiile comerciale clasice. Serviciile de curățare a halelor
                        implică utilizarea unor soluții chimice specifice și a unor echipamente de
                        mare putere, capabile să elimine depunerile de uleiuri, praf metalic sau
                        reziduuri de producție. Mentenanța corectă a acestor spații nu doar că
                        îmbunătățește vizibilitatea și siguranța, dar previne și degradarea
                        prematură a infrastructurii clădirii.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        O igienă riguroasă în depozite asigură conformitatea cu standardele SSM și
                        creează un mediu de lucru productiv. Ne concentrăm pe decontaminarea
                        completă a pardoselilor și a structurilor adiacente, urmând modele de
                        eficiență standardizate din industrie. Curățarea spațiului de depozitare nu
                        doar că îmbunătățește aspectul vizual, dar previne și degradarea prematură a
                        stocurilor de marfă cauzată de particulele fine de praf.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src={imgPardoseli114}
                        alt="Servicii de curățare hale industriale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        my={4}
                    />

                    <MKTypography variant="h3" mb={3} color="dark" mt={3}>
                        Consultanță și evaluarea nevoilor specifice pentru curățenia halei
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Fiecare unitate de producție are particularități care determină metoda de
                        intervenție. Procesul nostru începe cu o analiză preliminară detaliată
                        pentru a personaliza serviciile în funcție de tipul de activitate
                        desfășurată. În această fază, stabilim dacă este nevoie de o procedură de{" "}
                        <a
                            href="/curatenie-generala"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curatenie generala
                        </a>{" "}
                        sau de o întreținere periodică intensivă. Această evaluare preliminară este
                        esențială pentru a garanta că toate cerințele de siguranță sunt îndeplinite
                        înainte de începerea lucrărilor efective.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Cum lucrăm la Doral Cleaning
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Lucrăm pe bază de evaluare inițială, proceduri adaptate și planificare
                        operațională, pentru a asigura rezultate constante și sigure în spații
                        industriale de mari dimensiuni. Nu lăsăm nimic la voia întâmplării, deoarece
                        rigoarea tehnică este singura care garantează o igienă durabilă. Ne
                        coordonăm activitatea cu managerii de facilitate pentru a ne asigura că
                        fiecare etapă a procesului de igienizare respectă cerințele specifice ale
                        locației.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Tipuri de servicii profesionale din segmentul de curățenie industrială
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Tipuri de servicii profesionale din segmentul de curățenie industrială
                        oferite de echipa noastră acoperă toate zonele critice ale unei fabrici
                        moderne. Ne bazăm pe tehnologie avansată pentru a minimiza timpii de
                        execuție, folosindu-ne de bunele practici din domeniu. Un mediu de lucru
                        curat contribuie la creșterea moralului angajaților, aspect care se reflectă
                        direct în productivitatea generală a unității. Investiția în igiena
                        industrială este, în esență, o investiție în fiabilitatea întregului lanț de
                        producție.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src={image23}
                        alt="Tipuri de servicii profesionale de curatare industriala a halelor si depozitelor"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        my={4}
                    />

                    <MKBox component="ul" pl={4} mb={5}>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Curățenie depozite logistice și centre de distribuție:</strong>{" "}
                            Eliminarea urmelor de anvelope și a prafului de pe rafturile de
                            depozitare.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Curățenie hale industriale și spații de producție:</strong>{" "}
                            Igienizarea zonelor de lucru și eliminarea reziduurilor tehnice.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Întreținerea pardoselilor industriale:</strong> Servicii de
                            spălare mecanizată și degresare profesională disponibile pe{" "}
                            <a
                                href="/curatare-pardoseli"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                curatare pardoseli
                            </a>
                            .
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>
                                Curățenia zonelor de lucru, a căilor de acces și a platformelor
                                industriale:
                            </strong>{" "}
                            Menținerea vizibilității marcajelor și eliminarea riscurilor de
                            alunecare.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Curățenie în jurul utilajelor și echipamentelor:</strong>{" "}
                            Îndepărtarea acumulărilor de mizerie fără a afecta funcționarea
                            sistemelor mecanice.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Colectarea și gestionarea deșeurilor nepericuloase:</strong>{" "}
                            Sortarea și evacuarea deșeurilor rezultate din activitatea zilnică.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Curățenia zonelor administrative adiacente:</strong>{" "}
                            Întreținerea birourilor, a vestiarelor și a zonelor sanitare pentru
                            personal.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            <strong>Servicii speciale:</strong> Intervenții complexe de tip{" "}
                            <a
                                href="/curatenie-post-construct"
                                style={{
                                    textDecoration: "none",
                                    color: "#1A73E8",
                                    fontWeight: "bold",
                                }}
                            >
                                curatenie post construct
                            </a>{" "}
                            pentru facilități noi sau renovate.
                        </MKTypography>
                    </MKBox>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Certificări și garanții Doral Cleaning
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Certificările Doral Cleaning atestă faptul că toate procedurile noastre sunt
                        aliniate cu normele de siguranță și managementul calității. Folosim doar
                        substanțe aprobate care nu afectează sănătatea operatorilor sau integritatea
                        echipamentelor din hale. Fiecare lucrare beneficiază de o garanție de
                        execuție, în acest mod asigurândune clienții că rezultatul final va
                        corespunde întocmai standardelor agreate în faza de contractare.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark" mt={3}>
                        Sfaturile noastre pentru o mentenanță corectă
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Pentru a prelungi durata de viață a pardoselilor și pentru a menține un
                        ambient sănătos, recomandăm implementarea unui set de bune practici interne.
                        O igienă corectă începe cu raportarea imediată a oricărei scurgeri de
                        lichide tehnice. Implementarea unor protocoale de curățenie preventivă poate
                        reduce costurile cu reparațiile capitale ale pardoselilor industriale pe
                        termen lung.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Avantajele colaborării cu noi
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Avantajele colaborării cu noi derivă din expertiza practică dobândită în
                        locații cu fluxuri operaționale intense. Nu ne rezumăm doar la o simplă
                        curățare, ci oferim soluții integrate care mențin funcționalitatea spațiilor
                        dumneavoastră. Parteneriatul cu Doral Cleaning vă oferă siguranța unui
                        spațiu de lucru conform, gata să susțină ritmul afacerii dumneavoastră.
                    </MKTypography>

                    <MKBox component="ul" pl={4} mb={4}>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            Echipe specializate în intervenții pentru medii industriale complexe.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            Planificare strategică pentru menținerea fluxului de producție
                            neîntrerupt.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            Utilaje profesionale de mare putere pentru suprafețe extinse.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            Buget optimizat prin evaluarea tehnică a fiecărei hale.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={1}>
                            Reducerea riscurilor profesionale conform normelor europene actuale.
                        </MKTypography>
                    </MKBox>

                    <MKTypography variant="body1" color="text" mb={3}>
                        Am dezvoltat soluții care permit curățarea spațiilor fără a opri liniile de
                        producție, minimizând astfel impactul economic pentru beneficiar.
                        Feedback-ul clienților noștri confirmă că rigoarea și punctualitatea
                        echipelor Doral Cleaning sunt factori determinanți pentru o colaborare pe
                        termen lung, transformând igienizarea într-un proces previzibil și eficient.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Ai nevoie de serviciile unor profesioniști, care practica{" "}
                        <a
                            href="/tarife"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            preturi corecte
                        </a>
                        ? Ai ajuns unde trebuie.
                    </MKTypography>

                    <MKTypography variant="h2" mb={3} color="dark">
                        Unde lucrăm: în toate sectoarele Bucureștiului și în Ilfov
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={5}>
                        Sediul Doral Cleaning este pe Calea Șerban Vodă 82, în Sectorul 4, între
                        Unirii și Tineretului. De aici pleacă echipele noastre către clienții din
                        toate cele șase sectoare ale Bucureștiului și din Ilfov: Voluntari,
                        Pantelimon, Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și
                        Otopeni. Deplasarea pentru evaluarea spațiului este gratuită în București și
                        în Ilfov (iar pentru intervențiile efective de curățenie, tariful minim /
                        deplasarea este de 500 lei). Multe dintre halele și depozitele din jurul
                        Bucureștiului sunt în Ilfov, așa că lucrăm la fel de des în afara orașului
                        ca în interiorul lui, cu programul adaptat turelor.
                    </MKTypography>

                    <MKTypography variant="h3" mb={3} color="dark">
                        Întrebări frecvente (FAQs)
                    </MKTypography>

                    <MKBox mb={3}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Lucrați și în afara Sectorului 4?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Da. Sediul nostru este în Sectorul 4, dar lucrăm în toate sectoarele
                            Bucureștiului și în Ilfov, inclusiv în Voluntari, Pantelimon,
                            Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și Otopeni.
                            Deplasarea pentru evaluare este gratuită.
                        </MKTypography>
                    </MKBox>

                    <MKBox mb={3}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Intervenția echipei de curățenie va opri fluxul de producție?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Nu, deoarece intervențiile noastre sunt planificate strategic astfel
                            încât procesele dumneavoastră operaționale să se desfășoare fără blocaje
                            sau timpi morți, asigurând continuitatea activității fără întreruperi.
                            Putem lucra în afara orelor de program sau în weekend pentru a evita
                            suprapunerile.
                        </MKTypography>
                    </MKBox>

                    <MKBox mb={3}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Cum garantați siguranța utilajelor și a instalațiilor din hală?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Lucrările sunt realizate cu respectarea strictă a normelor de siguranță
                            și igienă, conform procedurilor specifice mediilor industriale,
                            contribuind astfel la menținerea unui spațiu de lucru sigur și
                            organizat. Operatorii noștri sunt instruiți să protejeze componentele
                            electronice și mecanice sensibile.
                        </MKTypography>
                    </MKBox>

                    <MKBox mb={3}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Personalul dumneavoastră este pregătit pentru riscurile din mediul
                            industrial?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Echipele noastre sunt formate exclusiv din personal instruit pentru
                            medii industriale, fiind pregătite să lucreze eficient în spații de mari
                            dimensiuni, în proximitatea utilajelor și în zonele cu trafic intens.
                            Fiecare membru al echipei are instructajul de protecție a muncii
                            efectuat.
                        </MKTypography>
                    </MKBox>

                    <MKBox mb={3}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Ce fel de dotări folosiți pentru a asigura curățenia în spații extinse?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Utilizăm tehnologie și echipamente profesionale de ultimă generație,
                            special adaptate pentru curățenia industrială, care ne permit să
                            asigurăm o eficiență sporită și rezultate constante pe suprafețe mari.
                            Folosim mașini automate de spălat și aspiratoare industriale de mare
                            capacitate.
                        </MKTypography>
                    </MKBox>

                    <MKBox mb={5}>
                        <MKTypography variant="h5" color="dark" mb={1}>
                            Serviciile pot fi personalizate în funcție de programul fabricii
                            noastre?
                        </MKTypography>
                        <MKTypography variant="body1" color="text">
                            Oferim flexibilitate totală și adaptare la cerințele fiecărui client,
                            astfel încât serviciile să fie ajustate specificului locației
                            dumneavoastră, indiferent dacă aveți nevoie de întreținere zilnică sau
                            de intervenții speciale. Graficul de lucru se stabilește de comun acord
                            pentru a nu perturba logistica internă.
                        </MKTypography>
                    </MKBox>

                    <MKTypography variant="body1" color="dark" fontWeight="bold" textAlign="center">
                        Dorești să programăm o primă vizită de evaluare tehnică pentru a stabili
                        planul de igienizare al halei tale?{" "}
                        <a
                            href="/contact-curatenie"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            Contactează-ne
                        </a>
                        !
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
